export default __webpack_public_path__ + "static/media/room1-MASK-tile.22678e19.png";